import { render, staticRenderFns } from "./DnsList.vue?vue&type=template&id=068e1c4c"
import script from "./DnsList.vue?vue&type=script&lang=js"
export * from "./DnsList.vue?vue&type=script&lang=js"
import style0 from "./DnsList.vue?vue&type=style&index=0&id=068e1c4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports